import { Type } from 'class-transformer';
import { ValueDisplayTextResultDto } from '../../../_models/common/value-display-text-result-dto';

export class WFEConflictDataResultDto {
    fieldName: string;

    @Type(() => ValueDisplayTextResultDto)
    scannedStepValue: ValueDisplayTextResultDto;

    @Type(() => ValueDisplayTextResultDto)
    verifyStepValue: ValueDisplayTextResultDto;
}
